"use client"

import { Navigation } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `NavigationIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const NavigationIcon = component(Icon)({ as: Navigation })
